"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AvailabilityStatus = void 0;
const AvailabilityStatus = exports.AvailabilityStatus = {
  Auction: 'auction',
  Available: 'available_for_registration',
  PreReg: 'pre_reg',
  Premium: 'premium',
  RegPremium: 'registry_premium',
  Taken: 'taken',
  Excluded: 'excluded',
  Reserved: 'reserved',
  Unsupported: 'tld_unsupported',
  // Errors
  CharacterInvalid: 'character_invalid',
  IdnError: 'us_idn_not_allowed',
  LanguageUnsupported: 'language_unsupported',
  PunycodeError: 'punycode_conversion_error',
  TldInvalid: 'tld_invalid',
  // Fake for Smart Default Tld
  SmartDefaultTld: 'smart_default_tld'
};